export const PROFESSIONAL_TYPES = [
  { value: 'financial_advisor', label: 'Financial Advisor', icon: '💼' },
  { value: 'estate_attorney', label: 'Estate Attorney', icon: '⚖️' },
  { value: 'cpa_tax', label: 'CPA & Tax Expert', icon: '📊' },
  { value: 'real_estate', label: 'Real Estate Expert', icon: '🏠' },
  { value: 'insurance', label: 'Insurance Specialist', icon: '🛡️' },
  { value: 'family_therapist', label: 'Family Therapist', icon: '❤️' }
];
